<template>
  <div class="integral-turntable">
    <header class="header flex">
      <div class="left flex">
        <div>我的积分：</div>
        <div>{{ integral_number }}</div>
      </div>
      <div class="right">积分兑换</div>
    </header>
    <div class="be-careful">（注：100积分=1张充值票）</div>
    <div class="turntable-box">
      <div class="title">{{ turntable_title }}</div>
      <div class="turntable">
        <div v-for="item in gradeData" :class="[item.class_name]"  :key="item.id" class="grade-title">{{ item.integral }}</div>
        <div class="luck-draw-btn" :class="{'start-rotate': go_luck_draw}" @click="attendLuck">
          <img :src="luck_draw" alt="" srcset="">
        </div>
      </div>
    </div>
    <div class="turntable-bottom"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LuckDrawImg from '../../assets/images/activity/pointer.png'
import UnLuckDrawImg from '../../assets/images/activity/pointer-disabled.png'
export default {
  props: {},
  data() {
    return {
      integral_number: 7554,
      turntable_title: '福利发放，不定期送积分',
      gradeData: [
        { integral: '50积分', id: 1, class_name: 'grade-50' },
        { integral: '100积分', id: 2, class_name: 'grade-100' },
        { integral: '200积分', id: 3, class_name: 'grade-200' },
        { integral: '300积分', id: 4, class_name: 'grade-300' },
        { integral: '400积分', id: 5, class_name: 'grade-400' },
        { integral: '500积分', id: 6, class_name: 'grade-500' },
      ],
      can_luck_draw: true, // 是否可以抽奖
      go_luck_draw: false, // 参加抽奖
    };
  },
  computed: {
    /**
     *
     * 抽奖btn图片
    */
    luck_draw() {
      return this.can_luck_draw ? LuckDrawImg : UnLuckDrawImg
    },
    ...mapGetters({
      platform: 'platform',
    }),
  },
  components: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
    /**
     *
     *
     * 参加抽奖
    */
    attendLuck() {
      if (!this.can_luck_draw) {
        return
      }
      this.go_luck_draw = true
      setTimeout(() =>{
        this.can_luck_draw = false
        this.go_luck_draw = false
      }, 2000)
      // if (this.platform === 'TENCENT_WECHAT_MP_VEHICLE') {
        console.log('通知中')
        // 微信
        wx.miniProgram.postMessage({data: {foo: true}})
        wx.miniProgram.reLaunch({
          url: '/pages/index/index'
        })
        console.log('通知完毕')
      // }
    }
  }
};
</script>

<style scoped lang="scss">
.integral-turntable {
  background-color: #ffffff;
  min-height: 100vh;
  .header {
    background-color: #F2F2F2;
    height: 90px;
    align-items: center;
    padding: 0 30px;
    justify-content: space-between;
    .left {
      align-items: center;
      :first-child {
        color: #656565;
        font-size: 24px;
      }
      :last-child {
        color: #FF6012;
        font-size: 30px;
      }
    }
    .right {
      color: #5572FD;
      font-size: 26px;
    }
  }
  .be-careful {
    background-color: #ffce7e;
    height: 40px;
    line-height: 40px;
    font-size: 22px;
    color: #FF6012;
    padding-left: 16px;
  }
  .turntable-box {
    padding: 60px;
    background-color: #FFA912;
    text-align: center;
    .title {
      color: #FFFFFF;
      font-size: 30px;
      padding-bottom: 50px;
    }
    .turntable {
      background-image: url('../../assets/images/activity/outer-ring.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      position: relative;
      width: 545px;
      height: 546px;
      margin: 0 auto;
      overflow: hidden;
      .grade-title {
        font-size: 24px;
        color: #f2113c;
        font-weight: bold;
        text-align: center;
        position: absolute;
        transform: rotate(-45deg);
      }
      .grade-50 {
        top: 22%;
        left: calc(50% - 120px);
        transform: rotate(-30deg);
      }
      .grade-100 {
        top: 22%;
        right: calc(50% - 130px);
        transform: rotate(30deg);
      }
      .grade-200 {
        right: 60px;
        transform: rotate(90deg);
        top: calc(546px / 2 - 12px);
      }
      .grade-300 {
        bottom: 110px;
        right: calc(50% - 120px);
        transform: rotate(150deg);
      }
      .grade-400 {
        bottom: 22%;
        left: calc(50% - 130px);
        transform: rotate(210deg);
      }
      .grade-500 {
        left: 60px;
        transform: rotate(270deg);
        top: calc(546px / 2 - 12px);
      }
      .luck-draw-btn {
        width: 230px;
        height: 230px;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -115px;
        margin-left: -115px;
        img {
          width: 100%;
        }
      }
      .start-rotate {
        transform-origin: 50% 50%;
        animation: rotateturntable 1s ease-in-out 0s 1 alternate forwards;
      }
    }
  }
  .turntable-bottom {
    height: 13px;
    background-image: url('../../assets/images/activity/turntable-bottom.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin-top: -10px;
  }
  @keyframes rotateturntable {
    from {
        transform: rotate(0deg);
    }
    to {    /*100%*/
        transform: rotate(990deg);
    }
  }
}
</style>
